import { AbstractControl, FormControl} from '@angular/forms';
import {    ICOAClassification } from '../../shared/models/classification';
import { ClassificationService } from '../../shared/services/classification.service';
export function NumbersOnlyValidator(control: AbstractControl) {
   // if (!control.value.match(/^[0-9]$/)) {
      if (!control.value.match(/^\d$/)) {
      return { invalidCodeName: true };
  } else {
    return null;
  }
}
// For numerics
export function ValidateNumeric(e) {
  if (e.shiftKey || e.ctrlKey || e.altKey) {
    e.preventDefault();
  } else {
    const key = e.keyCode;
    if (!((key === 8) || (key === 9) || (key === 46) ||
     (key >= 35 && key <= 40) || (key >= 48 && key <= 57) || (key >= 96 && key <= 105))) {
      e.preventDefault();
    }
  }
}


export function IsCodeNameExists(groupHeaderId: number, fiscalYearConfigID: number,  lineitems: ICOAClassification[]) {
     return function IsCodeNameExists(control: FormControl) {

        if (lineitems != null)   {
             if ( lineitems.filter(l => (l.code === control.value)).length > 0 ) {
             return { invalidCodeName: true };
        } else {
          return null;
        }
      }
     return null;
   }
}


